
import React, { Component } from 'react';
import NewsConfiguration from '../../../../src/models/NewsConfiguration';
import NewsArticle from '../../../../src/models/NewsArticle';
import Modal from "react-bootstrap/Modal";

type NewsModalAccordionItemProps = {
    configuration: NewsConfiguration,
    article: NewsArticle,
    index: number,
    active: boolean,
    onClick: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void
}

type NewsModalAccordionItemState = {
}

export default class NewsModalAccordionItem extends Component<NewsModalAccordionItemProps, NewsModalAccordionItemState> {

    constructor(props: NewsModalAccordionItemProps) {
        super(props);
        this.state = {
        };
    }

    public render() {
        return (
            <>
                <div onClick={this.props.onClick} className={"px-3 py-2 bg-white tab" + (this.props.active ? " activeTab" : "")}>
                    <div className="d-flex flex-row">
                        <div className="flex-grow-1">
                            <p className="text-overline small text-red font-weight-bolder my-1">{this.props.configuration.importantUpdateText} {this.props.article.publicationDate}</p>
        <p className="font-weight-bold mb-0 text-line-height-small">{this.props.article.title}</p>
                        </div>
                        <div className="d-flex d-md-none align-items-center">
                            <img className="ml-4 mr-2" src="/img/svg/icon-chevron-down.svg" alt="" />
                        </div>
                    </div>
                </div>

                <div className={"bg-ecru panel" + (this.props.active ? " activePanel" : "")}>
                    <div className="px-3 py-5" dangerouslySetInnerHTML={{ __html: this.props.article.html }} >
                    </div>
                </div>
            </>
        );
    }
}